import { ReactElement, useEffect, useMemo, useState } from 'react';

import { CrisRequestType } from 'app/constants';
import { SeamRequest } from 'app/model';
import { searchService } from 'app/services';
import { Strings } from 'app/utils/strings';
import { TupleResultsTable, TupleTableProps } from 'features/tuples/tuple-results-table';

export const PatternTuples: (
    props: Omit<TupleTableProps, 'gridApiRef'> & {
        seamRequest?: SeamRequest;
        type: CrisRequestType;
        ignoreDeactivated?: boolean;
    },
) => ReactElement = ({ tuples, seamRequest, type, ignoreDeactivated, ...props }) => {
    const [correctionPatIds, setCorrectionPatIds] = useState<Set<number>>();

    useEffect(() => {
        if (!ignoreDeactivated && seamRequest) {
            const requestTypeStr = Strings.seamRequestType(seamRequest);
            setCorrectionPatIds(undefined);
            searchService
                .findPatterns(
                    type,
                    seamRequest.store,
                    undefined,
                    undefined,
                    'Map' === requestTypeStr ? 'UNMAP' : 'MAP',
                    true,
                )
                .subscribe((results) => {
                    const newCorrectionPatIds = new Set(results.data.map(({ id }) => id));
                    setCorrectionPatIds(newCorrectionPatIds);
                });
        }
    }, [type, seamRequest, ignoreDeactivated]);

    const tuplesAffectedByPatterns = useMemo(() => {
        if (ignoreDeactivated) {
            return tuples;
        }

        if (!!seamRequest && !!correctionPatIds) {
            return tuples.map((tuplesArr) => {
                return tuplesArr.map((tuple) => ({
                    ...tuple,
                    affectedByActivePattern: correctionPatIds.has(+tuple.correctionPatId),
                }));
            });
        } else if (!seamRequest) {
            return tuples;
        }

        return [];
    }, [tuples, seamRequest, correctionPatIds, ignoreDeactivated]);

    return <TupleResultsTable tuples={tuplesAffectedByPatterns} {...props} />;
};
